import Client from '../../Client';

export default class Bay {
  constructor(
    Client,
    { id, name, max_duration, building_id, seq, enabled, created, modified }
  ) {
    if (!Client) throw new Error('Please provide an instance of Client');
    const { parseISODateTimeAsUTC } = Client;

    this.Client = Client;
    Object.defineProperty(this, 'Client', { enumerable: false });

    this.id = id || 0;
    this.name = name || '';
    this.max_duration = max_duration || 0;
    this.building_id = building_id || null;
    this.seq = seq || 0;
    this.enabled = Boolean(enabled);

    this.created = parseISODateTimeAsUTC(created);
    this.modified = parseISODateTimeAsUTC(modified);
  }
}
